import { resolveAndStoreNonEnumValueParam } from '@ui-common/utils'

import { User } from '../common/types'
import { getLoanOfferId } from '../utils/helpers'
import { QueryParams } from './types'

export const resolveAndStoreLoanOfferId = (): string | undefined => {
  return resolveAndStoreNonEnumValueParam(QueryParams.LoanOfferId)
}

export const resolveInitialLoanOfferId = (user: User): string | undefined => {
  const storedLoanOfferId = getLoanOfferId()
  return user.loanOffers.length === 1
    ? user.loanOffers[0]?.id
    : user.loanOffers.find((loanOffer) => loanOffer.id === storedLoanOfferId)?.id
}
